// !!! IMPORTANT !!!
// !!! DO NOT MODIFY THIS FILE !!!
// This method of creating feature flags is outdated, please add your FFs to: src/modules/feature_flags.ts

// Use this method to obtain booleans
export const FF_CLIENT_SIDE_NAVIGATION = localStorage.getItem('FF_CLIENT_SIDE_NAVIGATION') === 'true';
